import { Box } from '@mui/material';
import PageHeader from 'components/BaseLayout/PageHeader';
import MobileHeader from 'components/mobile/MobileHeader';
import { NotificationContextProvider } from 'core/providers/NotificationContextProvider';
import { periodSelector } from 'core/store/selectors/period.selector';
import { FC, useEffect, useMemo, useState } from 'react';
import { isCurrentMonth } from 'utils/dateUtils';
import { useAppDispatch, useAppSelector } from '../../core/hooks/hooks';
import { useEntityContext } from '../../core/hooks/useEntityContext';
import { listBudgets } from '../../core/store/actions/budgets.actions';
import { listExpenses } from '../../core/store/actions/expenses.actions';
import { budgetsSelector } from '../../core/store/selectors/budgets.selector';
import NotificationPanel from '../Shared/NotificationPanel';
import BudgetList from './BudgetList/BudgetList';
import EditBudgetForm from './BudgetList/EditBudgetForm';
import BudgetsMobileHeader from './mobile/BudgetsMobileHeader';

const Budgets: FC = () => {
  const dispatch = useAppDispatch();
  const [currentTab, setCurrentTab] = useState(0);
  const [isEditBudgetPanelOpen, setIsEditBudgetPanelOpen] =
    useState<boolean>(false);
  const context = useEntityContext<string>();
  const { budgets } = useAppSelector(budgetsSelector);

  const setTab = (tabValue: number) => setCurrentTab(tabValue);

  useEffect(() => {
    dispatch(listBudgets());
    dispatch(listExpenses());
  }, []);

  const openEditForm = () => {
    setIsEditBudgetPanelOpen(true);
  };

  const closeEditForm = () => {
    context.reset();
    setIsEditBudgetPanelOpen(false);
  };

  return (
    <NotificationContextProvider>
      <MobileHeader>
        <BudgetsMobileHeader
          currentTabIndex={currentTab}
          onSwitchTab={setTab}
          onAddBudget={openEditForm}
        />
      </MobileHeader>
      <Box
        sx={{
          mt: {
            xs: '100px',
            md: 0
          },
          mb: 9
        }}
      >
        <PageHeader
          title="Budgets"
          buttons={{
            buttons: [
              {
                title: 'Add budget',
                onClick: openEditForm
              }
            ]
          }}
        />
        <BudgetList
          context={context}
          openEditForm={openEditForm}
          budgets={budgets}
        />
        <EditBudgetForm
          isOpen={isEditBudgetPanelOpen}
          closePanel={closeEditForm}
          budgetId={context.current}
        />
        <NotificationPanel />
      </Box>
    </NotificationContextProvider>
  );
};

export default Budgets;
